import { render, staticRenderFns } from "./IncidenceComment.vue?vue&type=template&id=0907cd86&"
import script from "./IncidenceComment.vue?vue&type=script&lang=js&"
export * from "./IncidenceComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports